export default __webpack_public_path__ + "static/media/pjInfo.13cab09c.png";